module.exports = __webpack_public_path__ + "assets/smart-asset-website.12e5af61.svg";